import { render } from "./Notes-note-edit.vue?vue&type=template&id=6729580c&scoped=true&lang=pug"
import script from "./Notes-note-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Notes-note-edit.vue?vue&type=script&setup=true&lang=js"

import "./Notes-note-edit.vue?vue&type=style&index=0&id=6729580c&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6729580c"]])

export default __exports__